import { useLocation } from 'react-router'

import Link from 'tools/Link'
import { MaxViewPage } from 'tools/Uniform'
import { readableError } from 'utils/error'

// import { isRouteErrorResponse, useRouteError } from 'react-router'
const isRouteErrorResponse = () => false
const useRouteError = () => <></>

////////////////////////////////////////////////////////////////////////////////
export function ErrorBoundary() {
  let error = useRouteError()
  return (
    <div className="base-body" data-src-id="error-boundary">
      <MaxViewPage>
        <h1 className="mb4">Oh No!</h1>
        <VisualizeError content={error} />
      </MaxViewPage>
    </div>
  )
}

export function VisualizeError({ content }) {
  if (isRouteErrorResponse(content)) {
    return (
      <>
        <p>{content.statusText}</p>
        <p>
          {content.data} ({content.status})
        </p>
      </>
    )
  } else if (content instanceof Error) {
    // console.error("Stack Trace", {content})
    return <p>{readableError(content)}</p>
  } else {
    console.log({ 'Unknown Error': content })
    return <i>Unknown error (see logs)</i>
  }
}

export function PathNotFound() {
  const location = useLocation()
  return (
    <div className="base-body" data-src-id="path-not-found">
      <MaxViewPage>
        <h1 className="mb4">Oh No!</h1>
        <p>
          Page not found: <code>{location.pathname}</code>
        </p>
        {location.search && (
          <p>
            Query: <code>{location.search}</code>
          </p>
        )}
        <Link to="/">Go back home</Link>
      </MaxViewPage>
    </div>
  )
}
